<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Kullanıcılar</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Kullanıcı</div>
          </div>
        </div>
       <app-kullanici-liste [source]="kullanicilar" (updateKullanicilar)="getKullanicilar($event)" [showGrupInfo]="true" [showSubeInfo]="true"></app-kullanici-liste>
      </div>
    </div>
  </div>
</app-layout>
